const eventDetails = [
  {
    icon: "ri-calendar-event-fill",
    label: "Data e Horário",
    main: "08/04",
    sub: "19:30",
    subClass: "text-base sm:text-lg font-bold text-yellow-600",
  },
  {
    icon: "ri-map-pin-2-fill",
    label: "Local",
    main: "Tri Hotel & Flat",
    sub: "Caxias do Sul - RS",
    extra: "Rua Os Dezoito do Forte, 1818",
  },
  {
    icon: "ri-group-fill",
    label: "Formato",
    main: "Presencial",
  },
  {
    icon: "ri-alarm-warning-fill",
    label: "Vagas",
    main: "Limitadas",
    sub: "Por horário",
  },
];

export default function EventInfo() {
  return (
    <section className="py-16 sm:py-20 bg-gradient-to-b from-gray-50 to-white" id="evento">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-14">
          <h4 className="text-3xl sm:text-4xl md:text-5xl font-black text-black mb-3 px-4">
            Informações do{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-600">
              Evento
            </span>
          </h4>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 mb-8">
          {eventDetails.map((item) => (
            <div
              key={item.label}
              className="bg-white rounded-2xl p-5 sm:p-7 text-center border border-gray-100 hover:border-yellow-500 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className={`${item.icon} text-xl sm:text-2xl text-black`} />
              </div>
              <p className="text-xs sm:text-sm font-bold text-gray-500 mb-1">{item.label}</p>
              <p className="text-lg sm:text-xl font-black text-black">{item.main}</p>
              {item.sub && (
                <p className={item.subClass ?? "text-base sm:text-lg font-bold text-yellow-600"}>
                  {item.sub}
                </p>
              )}
              {item.extra && (
                <p className="text-xs text-gray-400 mt-0.5 leading-relaxed">{item.extra}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
